// extracted by mini-css-extract-plugin
export default {"topics-item":"TopicItem_topics-item__cAG2v","title":"TopicItem_title__C2QsX","actions":"TopicItem_actions__vxJeB","icon":"TopicItem_icon__Z8Now"};